export default function getColor(value) {
  const rounded = Math.ceil(value / 10) * 10;
  const colors = {
    0: {
      top: '#FF981E',
      bottom: '#FF002E',
    },
    10: {
      top: '#FFA927',
      bottom: '#FF3D00',
    },
    20: {
      top: '#FFB627',
      bottom: '#FF5C00',
    },
    30: {
      top: '#FED02C',
      bottom: '#F77B08',
    },
    40: {
      top: '#FFDD2C',
      bottom: '#F99909',
    },
    50: {
      top: '#EDD70D',
      bottom: '#E9A906',
    },
    60: {
      top: '#CFE102',
      bottom: '#C3A400',
    },
    70: {
      top: '#CFE44E',
      bottom: '#73A703',
    },
    80: {
      top: '#99DF40',
      bottom: '#65A533',
    },
    90: {
      top: '#58DF5D',
      bottom: '#48A639',
    },
    100: {
      top: '#30E52C',
      bottom: '#19A057',
    },
  };
  return colors[rounded];
}



// WEBPACK FOOTER //
// ./src/utils/colorLibrary.js